var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "loading",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_724",
    "data-name": "Rectangle 724",
    width: 125,
    height: 125,
    fill: "#989898"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_77725",
    "data-name": "Group 77725",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77727",
    "data-name": "Group 77727",
    transform: "translate(5.208 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M250.045,0a5.682,5.682,0,0,0-5.682,5.682V28.409a5.682,5.682,0,1,0,11.364,0V5.682A5.682,5.682,0,0,0,250.045,0Z",
    transform: "translate(-187.545 0)",
    fill: "#205a41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M250.047,372.364a5.682,5.682,0,0,0-5.682,5.682v22.727a5.682,5.682,0,0,0,11.364,0V378.046A5.682,5.682,0,0,0,250.047,372.364Z",
    transform: "translate(-187.547 -281.455)",
    fill: "#a3baad",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M105.57,85.9,89.5,69.827a5.682,5.682,0,0,0-8.035,8.035L97.535,93.934A5.682,5.682,0,0,0,105.57,85.9Z",
    transform: "translate(-63.159 -51.522)",
    fill: "#205a41",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M424.318,232.727H412.955a5.682,5.682,0,0,0,0,11.364h11.364a5.682,5.682,0,0,0,0-11.364Z",
    transform: "translate(-310.682 -175.909)",
    fill: "#a3baad",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M352.8,333.131a5.682,5.682,0,0,0-8.035,8.035l16.071,16.07a5.682,5.682,0,1,0,8.035-8.035Z",
    transform: "translate(-262.178 -250.543)",
    fill: "#a3baad",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M45.727,238.409a5.682,5.682,0,0,0-5.682-5.682H17.318a5.682,5.682,0,0,0,0,11.364H40.045A5.682,5.682,0,0,0,45.727,238.409Z",
    transform: "translate(-11.636 -175.909)",
    fill: "#205a41",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M105.571,333.13a5.682,5.682,0,0,0-8.035,0L81.465,349.2a5.682,5.682,0,1,0,8.035,8.035l16.07-16.071A5.681,5.681,0,0,0,105.571,333.13Z",
    transform: "translate(-63.159 -250.542)",
    fill: "#205a41",
    opacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.c712a3358f7c3cea6d78d406b1277106.svg";
export { ForwardRef as ReactComponent };